
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ManagerProfile from "@/components/profile/roles/ManagerProfile.vue";
  import AdminProfile from "@/components/profile/roles/AdminProfile.vue";
  import ContractorProfile from "@/components/profile/roles/ContractorProfile.vue";

  import { User } from "@/interface";
  import Roles from "@/entities/Roles";

  @Component({
    components: {
      ManagerProfile,
      AdminProfile,
      ContractorProfile,
    },
  })
  export default class Profile extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    created(): void {
      if(localStorage.getItem('timerRunning') === '1') {
        this.$root.$emit('timerStarted');
      }
    }

    get templateData(): Function {
      if (this.currentUser.role === Roles.MANAGER) {
        return ManagerProfile;
      }

      if (this.currentUser.role === Roles.CONTRACTOR) {
        return ContractorProfile;
      }

      return AdminProfile;
    }
  }
